module.exports = __webpack_public_path__ + "public/SiteIcons/docusVerifiMenu.svg?4e366b33";